module.exports = __webpack_public_path__ + "static/we-are-the-weather-bd93d297bd1db864ee5a2aeed56b3bfe.jpg";